var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'nav-buscador': _vm.buscadorMobile, 'd-none': !_vm.buscadorMobile }},[_c('Buscador'),_c('div',{staticClass:"invisible-buscador",on:{"click":_vm.buscadorToggle}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }